<div class="row mb-30">
  <div class="col-9">
    <h4 class="mb-5">Payment Details</h4>
  </div>
  <div class="col-3 text-right">
    <a href="javascript:" title="Add new payment method" data-dismiss="modal" (click)="openAddNewPaymentModal()" class="button-control"><svg class="icon">
      <use xlink:href="#plus"></use>
      </svg><strong></strong></a>
    </div>
  </div>

  <!-- Loading skeleton while API call is in progress -->
  @if (!bankPoliciesLoaded) {
    <div class="payment-listings">
      <div class="loading-skeleton">
        <div class="loading-skeleton__inner">
          <div class="loading-skeleton__thumb">
            <div class="loading-skeleton__img"></div>
          </div>
          <div class="loading-skeleton__content">
            <div class="loading-skeleton__title"></div>
            <div class="loading-skeleton__text"></div>
            <div class="loading-skeleton__text"></div>
          </div>
        </div>
      </div>
      <div class="loading-skeleton mt-15">
        <div class="loading-skeleton__inner">
          <div class="loading-skeleton__thumb">
            <div class="loading-skeleton__img"></div>
          </div>
          <div class="loading-skeleton__content">
            <div class="loading-skeleton__title"></div>
            <div class="loading-skeleton__text"></div>
            <div class="loading-skeleton__text"></div>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- No payment details found -->
  @if (bankPoliciesLoaded && !bankPolicies?.length) {
    <div class="table-noresults__content">
      <h3 class="font-normal">No payment details found</h3>
    </div>
  }

  @if (bankPoliciesLoaded && bankPolicies?.length) {
    @for (item of bankPolicies; track item) {
      <h6 class="tag-pill__heading font-16 mb-15">
        {{item?.grouping_name}}
        <!--<span class="tag-pill tag-pill&#45;&#45;active">Personal</span>-->
      </h6>
      <div class="payment-listings">
        @if (item?.person_banks?.length) {
          <ul class="list-unstyled">
            @for (bank of item?.person_banks; track bank) {
              <li>
                <div class="payment-listings__header">
                  <div class="payment-listings__header-icon">
                    <img [src]="bank?.transaction_icon" class="icon" alt="" />
                  </div>
                  <div class="payment-listings__header-title">
                    <h6>{{bank?.transaction_type_desc}}</h6>
                    <p class="text-color-grey-6">{{bank?.account_header}}</p>
                  </div>
                  <div class="payment-listings__header-actions">
                    <a (click)="editBankAccountDetails(bank)" href="#edit-payment-detail" data-toggle="modal" data-modal-type="static" class="action-edit">
                      <svg class="icon">
                        <use xlink:href="#edit"></use>
                      </svg>
                    </a>
                  </div>
                </div>
                @if (bank?.policies?.length) {
                  <ul class="payment-listings__items list-unstyled">
                    @for (policy of bank?.policies; track policy) {
                      <li>
                        <img [src]="policy?.category_icon" class="icon" alt="" />
                        <p>{{policy?.policy_header}}</p>
                        <a (click)="openChangeBankAccount(policy, bank)" href="#change-payment-modal" data-toggle="modal" data-modal-type="static" class="text-link">Change</a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        }
      </div>
    }
  }

  <!-- alert modal - change payment details -->
  <div class="modal fade modal--alert" id="change-payment-modal" tabindex="-1" role="dialog" aria-labelledby="change-payment-modal" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-alert modal-alert--alt">

        <div class="modal-alert__heading">
          <div class="container">
            <div class="modal-alert__avatar modal-alert__avatar--alt">
              <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <button class="modal-alert__close" data-dismiss="modal">
              <svg class="icon"><use xlink:href="#close-medium"></use></svg>
            </button>
          </div>
        </div>

        <div class="modal-alert__content">
          <div class="container">
            <div class="rte">
              <h3>Change Payment Details</h3>
            </div>

            @if (selectedPolicy) {
              <div [class]="'product-summary product-summary--' + (selectedPolicy?.category_css ? selectedPolicy?.category_css : 'personal') + ' mb-40'">
                <div class="product-summary__company">
                  <div class="product-summary__company-thumb">
                    <img [src]="'assets/insurer/' + selectedPolicy?.insurer_id + '-colour.svg'" alt="" class="img-fluid" />
                  </div>
                  <div class="product-summary__company-rating">
                    @if (selectedPolicy?.insurer_rating_parsed?.length) {
                      <div class="stars stars--sm">
                        @for (star of getStarPercent(selectedPolicy?.insurer_rating_parsed); track $index) {
                          <div class="stars__star">
                            <svg class="icon"><use xlink:href="#star-inactive"></use></svg>
                            <div [class]="'stars__percent stars__percent--' + star">
                              <svg class="icon"><use xlink:href="#star-active"></use></svg>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="product-summary__details">
                  <strong class="font-semibold">{{selectedPolicy.category_name}}</strong>
                  <h5>{{selectedPolicy?.product_name}}</h5>
                  <p><strong>{{selectedPolicy?.currency}} {{selectedPolicy?.premium_gross}}</strong> /{{selectedPolicy?.frequency_short}}</p>
                </div>
              </div>
            }

            @if (personBankAccounts?.length) {
              @for (account of personBankAccounts; track account) {
                <h6 class="tag-pill__heading font-16 mb-15">
                  {{account?.grouping_name}}
                  <!--<span class="tag-pill tag-pill&#45;&#45;active">Personal</span>-->
                </h6>
                <div class="form-group mb-30">
                  <!-- alternate smaller version of the custom selector control -->
                  @if (account?.person_banks?.length) {
                    @for (bank of account?.person_banks; track bank; let first = $first) {
                      <label class="custom-input custom-input--radio custom-input--payment">
                        <input
                          type="radio"
                          [checked]="selectedBank?.person_bank_id === bank?.person_bank_id || first"
                          (change)="selectedBank?.person_bank_id !== bank?.person_bank_id ? newPolicyBank = bank : newPolicyBank = null"
                          [name]="'person-bank-account'">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">
                            <span class="custom-input__label-text">
                              <h6>{{bank?.account_header}}</h6>
                              <p class="helper-text">{{bank?.transaction_type_desc}}</p>
                            </span>
                            <img [src]="bank?.account_type_logo" class="icon" alt="" />
                          </span>
                        </label>
                      }
                    }
                  </div>
                }
              }
            </div>
          </div>

          <div class="modal-alert__button">
            <div class="container">
              <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
              <a href="#"
                (click)="savePolicyNewBank()"
                [attr.disabled]="!newPolicyBank ? true :  null"
                class="button button--lg button--primary"
                data-dismiss="modal">
                Save
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /modal -->

    <!-- alert modal - edit payment details -->
    <div class="modal fade modal--alert" id="edit-payment-modal" tabindex="-1" role="dialog" aria-labelledby="edit-payment-modal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert modal-alert--alt">

          <div class="modal-alert__heading">
            <div class="container">
              <div class="modal-alert__avatar modal-alert__avatar--alt">
                <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
              </div>
              <button class="modal-alert__close" data-dismiss="modal">
                <svg class="icon"><use xlink:href="#close-medium"></use></svg>
              </button>
            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h3>Edit Payment Details</h3>
              </div>

              @if (personBankAccounts?.length) {
                @for (account of personBankAccounts; track account) {
                  <h6 class="tag-pill__heading font-16 mb-15">
                    {{account?.grouping_name}}
                    <!--<span class="tag-pill tag-pill&#45;&#45;active">Personal</span>-->
                  </h6>
                  <div class="form-group mb-30">
                    <!-- alternate smaller version of the custom selector control -->
                    @if (account?.person_banks?.length) {
                      @for (bank of account?.person_banks; track bank; let first = $first) {
                        <label class="custom-input custom-input--radio custom-input--payment">
                          <input
                            type="radio"
                            [checked]="selectedBank?.person_bank_id === bank?.person_bank_id || first"
                            (change)="selectedBank?.person_bank_id !== bank?.person_bank_id ? newPolicyBank = bank : newPolicyBank = null"
                            name="edit-person-bank-account">
                            <span class="custom-input__indi"></span>
                            <span class="custom-input__label">
                              <span class="custom-input__label-text">
                                <h6>{{bank?.account_header}}</h6>
                                <p class="helper-text">{{bank?.transaction_type_desc}}</p>
                                <span class="action-row">
                                  <a
                                    href="#" data-dismiss="modal"
                                    (click)="editBankAccountDetails(bank)"
                                  class="text-link">Edit</a>
                                  <!--<span></span>
                                  <a href="#" class="text-link">Remove</a>-->
                                </span>
                              </span>
                              <img [src]="bank?.account_type_logo" class="icon" alt="" />
                            </span>
                          </label>
                        }
                      }
                    </div>
                  }
                }

                <div class="text-left">
                  <a href="#" data-dismiss="modal" (click)="openAddNewPaymentModal()" class="button-control button-control--tight">
                    <svg class="icon icon--sm"><use xlink:href="#plus"></use></svg><strong>Add new payment method</strong>
                  </a>
                </div>
              </div>
            </div>

            <div class="modal-alert__button">
              <div class="container">
                <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
                <a
                  href="#"
                  [attr.disabled]="!newPolicyBank ? true : null"
                  (click)="continueToConfirmModalFromTransferModal()"
                  class="button button--lg button--primary"
                data-dismiss="modal">Save</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /modal -->

      <!-- alert modal - add new payment method -->
      <div class="modal fade modal--alert" id="add-new-payment-modal" tabindex="-1" role="dialog" aria-labelledby="add-new-payment-modal" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-alert modal-alert--alt">

            <div class="modal-alert__heading">
              <div class="container">
                <!-- <a href="#edit-payment-modal" class="modal-alert__back" data-toggle="modal" data-modal-type="static" data-dismiss="modal">
                <svg class="icon"><use xlink:href="#left-small"></use></svg>
                <strong>Back</strong>
              </a> -->
              <div class="modal-alert__avatar modal-alert__avatar--alt">
                <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
              </div>
              <button class="modal-alert__close" data-dismiss="modal">
                <svg class="icon"><use xlink:href="#close-medium"></use></svg>
              </button>
            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h3>Add New Payment Method</h3>
              </div>

              <div id="new-payment-type-accordion" class="mb-10">
                <div class="selectable" [ngClass]="{'is-selected': newPaymentMethodTransactionType === PaymentDetailsTransactionTypes.Debit_Order}">
                  <a
                    href="#debit-order-payment-option"
                    (click)="newPaymentMethodTransactionType = PaymentDetailsTransactionTypes.Debit_Order"
                    data-toggle="collapse" class="selectable__head" aria-expanded="true">
                    <div class="selectable__select">
                      <label class="custom-input custom-input--lg custom-input--radio">
                        <input
                          type="radio"
                          [checked]="newPaymentMethodTransactionType === PaymentDetailsTransactionTypes.Debit_Order"
                          name="transaction-type" />
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Debit Order</span>
                        </label>
                      </div>

                      <aside class="selectable__aside">
                        <div class="selectable__aside-logos"></div>
                      </aside>
                    </a>
                    <div class="selectable__content collapse show" id="debit-order-payment-option" data-parent="#new-payment-type-accordion">
                      <div class="selectable__content-inner">

                        <form [formGroup]="debitOrderForm">
                          <!--<div class="form-group form-group&#45;&#45;sm">
                          <label class="custom-input custom-input&#45;&#45;toggle">
                            <input type="checkbox" checked value="a" name="personal-or-business">
                            <span class="custom-input__answer">Personal</span>
                            <span class="custom-input__answer">Business</span>
                          </label>
                        </div>-->

                        <div class="form-group form-group--sm mb-10">
                          <app-question-dropdown
                            [options]="dropdownBanks"
                            [showOptionLabel]="true"
                            [labelText]="'Select Bank'"
                            (questionAnswer)="changeBank($event)">
                          </app-question-dropdown>
                          @if (submitted && debitOrderForm.get('bank')?.errors?.required) {
                            <div class="invalid-feedback">
                              <p>Required</p>
                            </div>
                          }
                        </div>

                        <div class="form-group form-group--sm mb-10">
                          <input type="text" class="form-control" placeholder="Branch Code" formControlName="branchCode" />
                          @if (submitted && debitOrderForm.get('branchCode')?.errors?.required) {
                            <div class="invalid-feedback">
                              <p>Required</p>
                            </div>
                          }
                        </div>

                        <div class="form-group form-group--sm mb-10">
                          <app-question-dropdown
                            [options]="accountTypes"
                            [labelText]="'Account Type'"
                            [showOptionLabel]="true"
                            (questionAnswer)="changeAccountType($event)">
                          </app-question-dropdown>
                          @if (submitted && debitOrderForm.get('accountType')?.errors?.required) {
                            <div class="invalid-feedback">
                              <p>Required</p>
                            </div>
                          }
                        </div>

                        <div class="form-group form-group--sm mb-10">
                          <input type="text" class="form-control" placeholder="Account Name" formControlName="accountName" />
                          @if (submitted && debitOrderForm.get('accountName')?.errors?.required) {
                            <div class="invalid-feedback">
                              <p>Required</p>
                            </div>
                          }
                        </div>

                        <div class="form-group form-group--sm mb-10">
                          <input type="text" class="form-control" placeholder="Account Number" formControlName="accountNumber" />
                          @if (submitted && debitOrderForm.get('accountNumber')?.errors?.required) {
                            <div class="invalid-feedback">
                              <p>Required</p>
                            </div>
                          }
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-alert__button">
            <div class="container">
              <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
              <a  href="javascript:;" (click)="submitNewPaymentMethod()"
                class="button button--lg button--primary" data-dismiss="modal" data-toggle="modal" data-modal-type="static">
                Save
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /modal -->

    <!-- alert modal - confirm update payment details -->
    <div class="modal fade modal--alert" id="confirm-update-modal" tabindex="-1" role="dialog" aria-labelledby="confirm-update-modal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert modal-alert--alt">

          <div class="modal-alert__heading">
            <div class="container">
              <a href="#edit-payment-modal" class="modal-alert__back" data-toggle="modal" data-modal-type="static" data-dismiss="modal">
                <svg class="icon"><use xlink:href="#arrow-left"></use></svg>
                <strong> Back</strong>
              </a>
              <div class="modal-alert__avatar modal-alert__avatar--alt">
                <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
              </div>
              <button class="modal-alert__close" data-dismiss="modal">
                <svg class="icon"><use xlink:href="#close-medium"></use></svg>
              </button>
            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h3>Please Note</h3>
                <p class="font-18">Editing the payment details will affect all the policies linked to it. </p>
              </div>
              @if (selectedEditBankAccountPolicies?.length) {
                @for (policy of selectedEditBankAccountPolicies; track policy) {
                  <div
                    [class]="'product-summary product-summary--' + (policy?.category_css ? policy?.category_css : 'personal') + ' mb-10'">
                    <div class="product-summary__company">
                      <div class="product-summary__company-thumb">
                        <img [src]="'assets/insurer/' + policy?.insurer_id + '-colour.svg'" alt="" class="img-fluid" />
                      </div>
                      <div class="product-summary__company-rating">
                        @if (policy?.insurer_rating_parsed?.length) {
                          <div class="stars stars--sm">
                            @for (star of getStarPercent(policy?.insurer_rating_parsed); track $index) {
                              <div class="stars__star">
                                <svg class="icon"><use xlink:href="#star-inactive"></use></svg>
                                <div [class]="'stars__percent stars__percent--' + star">
                                  <svg class="icon"><use xlink:href="#star-active"></use></svg>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="product-summary__details">
                      <strong class="font-semibold">{{policy?.category_name}}</strong>
                      <h5>{{policy?.policy_header}}</h5>
                      <p><strong>{{policy?.currency}} {{policy?.premium_gross}}</strong> /{{policy?.frequency_short}}</p>
                    </div>
                  </div>
                }
              }
            </div>
          </div>

          <div class="modal-alert__button">
            <div class="container">
              <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
              <a
                href="#"
                (click)="saveEditPaymentDetails()"

                class="button button--lg button--primary"
              data-dismiss="modal">Continue</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /modal -->

    <!-- alert modal - trrsfer policies confirm update payment details -->
    <div class="modal fade modal--alert" id="transfer-confirm-update-modal" tabindex="-1" role="dialog" aria-labelledby="transfer-confirm-update-modal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert modal-alert--alt">

          <div class="modal-alert__heading">
            <div class="container">
              <a href="#edit-payment-modal" class="modal-alert__back" data-toggle="modal" data-modal-type="static" data-dismiss="modal">
                <svg class="icon"><use xlink:href="#arrow-left"></use></svg>
                <strong>Back</strong>
              </a>
              <div class="modal-alert__avatar modal-alert__avatar--alt">
                <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
              </div>
              <button class="modal-alert__close" data-dismiss="modal">
                <svg class="icon"><use xlink:href="#close-medium"></use></svg>
              </button>
            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h3>Please Note</h3>
                <p class="font-18">Editing the payment details will affect all the policies linked to it as well: </p>
              </div>

              @if (selectedEditBankAccountPolicies?.length) {
                @for (policy of selectedEditBankAccountPolicies; track policy) {
                  <div
                    [class]="'product-summary product-summary--' + (policy?.category_css ? policy?.category_css : 'personal') + ' mb-10'">
                    <div class="product-summary__company">
                      <div class="product-summary__company-thumb">
                        <img [src]="'assets/insurer/' + policy?.insurer_id + '-colour.svg'" alt="" class="img-fluid" />
                      </div>
                      <div class="product-summary__company-rating">
                        @if (policy?.insurer_rating_parsed?.length) {
                          <div class="stars stars--sm">
                            @for (star of getStarPercent(policy?.insurer_rating_parsed); track $index) {
                              <div class="stars__star">
                                <svg class="icon"><use xlink:href="#star-inactive"></use></svg>
                                <div [class]="'stars__percent stars__percent--' + star">
                                  <svg class="icon"><use xlink:href="#star-active"></use></svg>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="product-summary__details">
                      <strong class="font-semibold">{{policy?.category_name}}</strong>
                      <h5>{{policy?.policy_header}}</h5>
                      <p><strong>{{policy?.currency}} {{policy?.premium_gross}}</strong> /{{policy?.frequency_short}}</p>
                    </div>
                  </div>
                }
              }
            </div>
          </div>

          <div class="modal-alert__button">
            <div class="container">
              <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
              <a
                href="#"
                (click)="saveTransferPoliciesBank()"
                class="button button--lg button--primary"
              data-dismiss="modal">Continue</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /modal -->

    <!-- alert modal - edit payment detail -->
    <div class="modal fade modal--alert" id="edit-payment-detail" tabindex="-1" role="dialog"
      aria-labelledby="edit-payment-detail" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert modal-alert--alt">

          <div class="modal-alert__heading">
            <div class="modal-alert__heading">
              <div class="container">
                <!-- <a href="#edit-payment-modal" class="modal-alert__back" data-toggle="modal" data-dismiss="modal">
                <svg class="icon">
                  <use xlink:href="#left-small"></use>
                </svg>
                <strong> Back</strong>
              </a> -->
              <div class="modal-alert__avatar modal-alert__avatar--alt">
                <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
              </div>
              <button class="modal-alert__close" data-dismiss="modal">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </button>
            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h3>Edit Payment Details</h3>
              </div>

              <div id="payment-option-accordion" class="mb-10">

                @if (selectedEditBankAccount?.transaction_type === PaymentDetailsTransactionTypes.Debit_Order) {
                  <div class="selectable is-static is-selected"
                    >
                    <div class="selectable__head">
                      <div class="selectable__select">
                        <label class="custom-input custom-input--lg custom-input--radio">
                          <span class="custom-input__label">Debit Order</span>
                        </label>
                      </div>
                      <aside class="selectable__aside">
                        <div class="selectable__aside-logos"></div>
                      </aside>
                    </div>
                    <div class="selectable__content">
                      <div class="selectable__content-inner">
                        <form [formGroup]="editDebitOrderForm">
                          <div class="form-group form-group--sm mb-10">
                            <app-question-dropdown
                              [options]="dropdownBanks"
                              [showOptionLabel]="true"
                              [selectedValue]="selectedEditBankAccount?.bank_id"
                              [labelText]="'Select Bank'"
                              (questionAnswer)="changeBank($event)">
                            </app-question-dropdown>
                            @if (submitted && debitOrderForm.get('bank')?.errors?.required) {
                              <div class="invalid-feedback">
                                <p>Required</p>
                              </div>
                            }
                          </div>
                          <div class="form-group form-group--sm mb-10">
                            <input type="text" class="form-control" placeholder="Branch Code" formControlName="branchCode"/>
                            @if (submitted && debitOrderForm.get('branchCode')?.errors?.required) {
                              <div
                                class="invalid-feedback">
                                <p>Required</p>
                              </div>
                            }
                          </div>
                          <div class="form-group form-group--sm mb-10">
                            <app-question-dropdown
                              [options]="accountTypes"
                              [labelText]="'Account Type'"
                              [selectedValue]="selectedEditBankAccount?.acc_type?.toString()"
                              [showOptionLabel]="true"
                              (questionAnswer)="changeAccountType($event)">
                            </app-question-dropdown>
                            @if (submitted && debitOrderForm.get('accountType')?.errors?.required) {
                              <div
                                class="invalid-feedback">
                                <p>Required</p>
                              </div>
                            }
                          </div>
                          <div class="form-group form-group--sm mb-10">
                            <input type="text" class="form-control" placeholder="Account Name"
                              formControlName="accountName"/>
                              @if (submitted && debitOrderForm.get('accountName')?.errors?.required) {
                                <div
                                  class="invalid-feedback">
                                  <p>Required</p>
                                </div>
                              }
                            </div>
                            <div class="form-group form-group--sm mb-10">
                              <input type="text" class="form-control" placeholder="Account Number"
                                formControlName="accountNumber"/>
                                @if (submitted && debitOrderForm.get('accountNumber')?.errors?.required) {
                                  <div
                                    class="invalid-feedback">
                                    <p>Required</p>
                                  </div>
                                }
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="modal-alert__button">
                <div class="container">
                  <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
                  <a
                    href="javascript:;"
                    (click)="continueToConfirmModal()"
                    data-dismiss="modal"
                    class="button button--lg button--primary"
                  >Save</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /modal -->
